const Angle01Icon = /*#__PURE__*/ [
  ["path", { d: "M21 20H6.47347C4.36707 20 3.31387 20 3.05177 19.3827C2.78966 18.7654 3.53439 18.0388 5.02384 16.5858L17.9249 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 20C11 17.3517 9.77371 15.0655 8 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { Angle01Icon as default };
//# sourceMappingURL=Angle01Icon.js.map
